import React from 'react';

export default function SVGPlayStoreButton(): JSX.Element {
  return (
    <svg width="158" height="47" viewBox="0 0 158 47" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.90332 5C0.90332 2.23857 3.1419 0 5.90332 0H153C155.761 0 158 2.23858 158 5V41.9582C158 44.7196 155.761 46.9582 153 46.9582H5.90331C3.14189 46.9582 0.90332 44.7196 0.90332 41.9582V5Z"
        fill="black"
      />
      <path
        d="M80.1918 25.5349C77.4548 25.5349 75.224 27.6351 75.224 30.5277C75.224 33.4027 77.4548 35.5205 80.1918 35.5205C82.9299 35.5205 85.1607 33.4027 85.1607 30.5277C85.1595 27.6351 82.9288 25.5349 80.1918 25.5349ZM80.1918 33.5553C78.6918 33.5553 77.399 32.3074 77.399 30.5289C77.399 28.7315 78.693 27.5024 80.1918 27.5024C81.6918 27.5024 82.9846 28.7315 82.9846 30.5289C82.9846 32.3062 81.6918 33.5553 80.1918 33.5553ZM69.3533 25.5349C66.6163 25.5349 64.3855 27.6351 64.3855 30.5277C64.3855 33.4027 66.6163 35.5205 69.3533 35.5205C72.0914 35.5205 74.3222 33.4027 74.3222 30.5277C74.3222 27.6351 72.0914 25.5349 69.3533 25.5349ZM69.3533 33.5553C67.8533 33.5553 66.5605 32.3074 66.5605 30.5289C66.5605 28.7315 67.8545 27.5024 69.3533 27.5024C70.8533 27.5024 72.1461 28.7315 72.1461 30.5289C72.1473 32.3062 70.8533 33.5553 69.3533 33.5553ZM56.4621 27.068V29.1859H61.4868C61.3367 30.3774 60.9434 31.2473 60.3429 31.8519C59.6121 32.5892 58.4682 33.4027 56.4621 33.4027C53.369 33.4027 50.9509 30.8869 50.9509 27.7666C50.9509 24.6462 53.369 22.1304 56.4621 22.1304C58.1308 22.1304 59.3491 22.7925 60.2487 23.6436L61.73 22.1492C60.4733 20.9388 58.8057 20.0126 56.4621 20.0126C52.2251 20.0126 48.6631 23.4922 48.6631 27.7666C48.6631 32.0409 52.2251 35.5205 56.4621 35.5205C58.7487 35.5205 60.4744 34.7633 61.8231 33.3452C63.2102 31.9458 63.642 29.9783 63.642 28.3899C63.642 27.8992 63.6047 27.4449 63.5291 27.0669H56.4621V27.068ZM109.186 28.7128C108.774 27.5975 107.517 25.5349 104.949 25.5349C102.399 25.5349 100.28 27.5588 100.28 30.5277C100.28 33.3264 102.381 35.5205 105.192 35.5205C107.46 35.5205 108.773 34.1212 109.318 33.3076L107.63 32.1724C107.068 33.0047 106.299 33.553 105.192 33.553C104.087 33.553 103.299 33.0423 102.793 32.0397L109.411 29.2786L109.186 28.7128ZM102.437 30.3774C102.381 28.4474 103.918 27.4648 105.025 27.4648C105.887 27.4648 106.618 27.9004 106.862 28.5238L102.437 30.3774ZM97.057 35.2188H99.2307V20.5432H97.057V35.2188ZM93.4938 26.6513H93.4193C92.9317 26.0643 91.9938 25.5349 90.8139 25.5349C88.3387 25.5349 86.0707 27.729 86.0707 30.5477C86.0707 33.3464 88.3387 35.5217 90.8139 35.5217C91.995 35.5217 92.9317 34.9922 93.4193 34.3877H93.4938V35.1061C93.4938 37.0161 92.4814 38.0375 90.8511 38.0375C89.5198 38.0375 88.6948 37.0737 88.3573 36.2601L86.464 37.0549C87.0075 38.3779 88.4504 40.005 90.8511 40.005C93.4007 40.005 95.557 38.4918 95.557 34.8032V25.8389H93.495V26.6513H93.4938ZM91.0012 33.5553C89.5012 33.5553 88.2456 32.2875 88.2456 30.5477C88.2456 28.7879 89.5012 27.5024 91.0012 27.5024C92.4814 27.5024 93.6439 28.7879 93.6439 30.5477C93.6439 32.2875 92.4814 33.5553 91.0012 33.5553ZM119.373 20.5432H114.17V35.2188H116.34V29.659H119.372C121.778 29.659 124.145 27.9016 124.145 25.1017C124.145 22.3018 121.779 20.5432 119.373 20.5432ZM119.429 27.6163H116.34V22.5859H119.429C121.052 22.5859 121.974 23.9418 121.974 25.1017C121.974 26.2381 121.052 27.6163 119.429 27.6163ZM132.848 25.509C131.276 25.509 129.648 26.2075 128.974 27.756L130.901 28.5672C131.313 27.756 132.081 27.4907 132.885 27.4907C134.008 27.4907 135.15 28.1704 135.169 29.3784V29.5298C134.775 29.3033 133.933 28.964 132.904 28.964C130.827 28.964 128.711 30.1156 128.711 32.2675C128.711 34.2315 130.415 35.4959 132.323 35.4959C133.783 35.4959 134.588 34.8349 135.093 34.0601H135.167V35.193H137.264V29.5662C137.266 26.9624 135.336 25.509 132.848 25.509ZM132.585 33.5518C131.875 33.5518 130.883 33.1926 130.883 32.3051C130.883 31.1722 132.119 30.7378 133.186 30.7378C134.139 30.7378 134.589 30.9456 135.169 31.2285C135 32.5892 133.84 33.5518 132.585 33.5518ZM144.9 25.8295L142.411 32.1924H142.337L139.754 25.8295H137.415L141.288 34.7222L139.08 39.6693H141.344L147.315 25.8295H144.9ZM125.344 35.2188H127.514V20.5432H125.344V35.2188Z"
        fill="white"
      />
      <path
        d="M56.0823 12.0248C56.0823 13.0085 55.7937 13.7916 55.2154 14.3762C54.5591 15.0712 53.7026 15.4187 52.6506 15.4187C51.6429 15.4187 50.7852 15.0665 50.0812 14.3621C49.376 13.6566 49.0234 12.7831 49.0234 11.7407C49.0234 10.697 49.376 9.8236 50.0812 9.11923C50.7852 8.41368 51.6429 8.0615 52.6506 8.0615C53.151 8.0615 53.6293 8.16011 54.0831 8.35616C54.5381 8.55338 54.9023 8.81518 55.1746 9.14271L54.5614 9.76256C54.0994 9.20493 53.4629 8.9267 52.6495 8.9267C51.914 8.9267 51.2786 9.18732 50.7422 9.70856C50.2057 10.2298 49.9381 10.9072 49.9381 11.7395C49.9381 12.5718 50.2057 13.2492 50.7422 13.7704C51.2786 14.2917 51.914 14.5523 52.6495 14.5523C53.4291 14.5523 54.0796 14.2905 54.5998 13.7657C54.9373 13.4241 55.1327 12.9487 55.1851 12.3394H52.6495V11.493H56.0323C56.0672 11.6773 56.0823 11.8545 56.0823 12.0248Z"
        fill="white"
      />
      <path
        d="M61.447 9.0829H58.2678V11.3158H61.1351V12.1622H58.2678V14.3951H61.447V15.2614H57.3706V8.2177H61.447V9.0829Z"
        fill="white"
      />
      <path d="M65.23 15.2614H64.3328V9.0829H62.3824V8.2177H67.1803V9.0829H65.23V15.2614Z" fill="white" />
      <path d="M70.6515 15.2614V8.2177H71.5487V15.2614H70.6515Z" fill="white" />
      <path d="M75.5275 15.2614H74.6303V9.0829H72.68V8.2177H77.4778V9.0829H75.5275V15.2614Z" fill="white" />
      <path
        d="M86.5601 14.3516C85.8735 15.063 85.0205 15.4187 84 15.4187C82.9794 15.4187 82.1265 15.063 81.4411 14.3516C80.7545 13.6402 80.4124 12.7691 80.4124 11.7396C80.4124 10.71 80.7545 9.83892 81.4411 9.1275C82.1265 8.41609 82.9794 8.0592 84 8.0592C85.0147 8.0592 85.8665 8.41726 86.5554 9.1322C87.2443 9.84714 87.5888 10.7159 87.5888 11.7396C87.5888 12.7691 87.2455 13.6402 86.5601 14.3516ZM82.1032 13.7611C82.6199 14.2894 83.2517 14.5524 84 14.5524C84.7482 14.5524 85.3813 14.2882 85.8968 13.7611C86.4135 13.2328 86.673 12.559 86.673 11.7396C86.673 10.9201 86.4135 10.2463 85.8968 9.718C85.3813 9.18972 84.7482 8.92676 84 8.92676C83.2517 8.92676 82.6199 9.1909 82.1032 9.718C81.5877 10.2463 81.3282 10.9201 81.3282 11.7396C81.3282 12.559 81.5877 13.2328 82.1032 13.7611Z"
        fill="white"
      />
      <path
        d="M88.8479 15.2614V8.2177H89.9394L93.3327 13.6965H93.3711L93.3327 12.3395V8.2177H94.2299V15.2614H93.2931L89.7428 9.5161H89.7044L89.7428 10.8732V15.2614H88.8479Z"
        fill="white"
      />
      <path
        d="M56.0823 12.0248C56.0823 13.0085 55.7937 13.7916 55.2154 14.3762C54.5591 15.0712 53.7026 15.4187 52.6506 15.4187C51.6429 15.4187 50.7852 15.0665 50.0812 14.3621C49.376 13.6566 49.0234 12.7831 49.0234 11.7407C49.0234 10.697 49.376 9.8236 50.0812 9.11923C50.7852 8.41368 51.6429 8.0615 52.6506 8.0615C53.151 8.0615 53.6293 8.16011 54.0831 8.35616C54.5381 8.55338 54.9023 8.81518 55.1746 9.14271L54.5614 9.76256C54.0994 9.20493 53.4629 8.9267 52.6495 8.9267C51.914 8.9267 51.2786 9.18732 50.7422 9.70856C50.2057 10.2298 49.9381 10.9072 49.9381 11.7395C49.9381 12.5718 50.2057 13.2492 50.7422 13.7704C51.2786 14.2917 51.914 14.5523 52.6495 14.5523C53.4291 14.5523 54.0796 14.2905 54.5998 13.7657C54.9373 13.4241 55.1327 12.9487 55.1851 12.3394H52.6495V11.493H56.0323C56.0672 11.6773 56.0823 11.8545 56.0823 12.0248Z"
        stroke="white"
        strokeWidth="0.22928"
        strokeMiterlimit="10"
      />
      <path
        d="M61.447 9.0829H58.2678V11.3158H61.1351V12.1622H58.2678V14.3951H61.447V15.2614H57.3706V8.2177H61.447V9.0829Z"
        stroke="white"
        strokeWidth="0.22928"
        strokeMiterlimit="10"
      />
      <path
        d="M65.23 15.2614H64.3328V9.0829H62.3824V8.2177H67.1803V9.0829H65.23V15.2614Z"
        stroke="white"
        strokeWidth="0.22928"
        strokeMiterlimit="10"
      />
      <path
        d="M70.6515 15.2614V8.2177H71.5487V15.2614H70.6515Z"
        stroke="white"
        strokeWidth="0.22928"
        strokeMiterlimit="10"
      />
      <path
        d="M75.5275 15.2614H74.6303V9.0829H72.68V8.2177H77.4778V9.0829H75.5275V15.2614Z"
        stroke="white"
        strokeWidth="0.22928"
        strokeMiterlimit="10"
      />
      <path
        d="M86.5601 14.3516C85.8735 15.063 85.0205 15.4187 84 15.4187C82.9794 15.4187 82.1265 15.063 81.4411 14.3516C80.7545 13.6402 80.4124 12.7691 80.4124 11.7396C80.4124 10.71 80.7545 9.83892 81.4411 9.1275C82.1265 8.41609 82.9794 8.0592 84 8.0592C85.0147 8.0592 85.8665 8.41726 86.5554 9.1322C87.2443 9.84714 87.5888 10.7159 87.5888 11.7396C87.5888 12.7691 87.2455 13.6402 86.5601 14.3516ZM82.1032 13.7611C82.6199 14.2894 83.2517 14.5524 84 14.5524C84.7482 14.5524 85.3813 14.2882 85.8968 13.7611C86.4135 13.2328 86.673 12.559 86.673 11.7396C86.673 10.9201 86.4135 10.2463 85.8968 9.718C85.3813 9.18972 84.7482 8.92676 84 8.92676C83.2517 8.92676 82.6199 9.1909 82.1032 9.718C81.5877 10.2463 81.3282 10.9201 81.3282 11.7396C81.3282 12.559 81.5877 13.2328 82.1032 13.7611Z"
        stroke="white"
        strokeWidth="0.22928"
        strokeMiterlimit="10"
      />
      <path
        d="M88.8479 15.2614V8.2177H89.9394L93.3327 13.6965H93.3711L93.3327 12.3395V8.2177H94.2299V15.2614H93.2931L89.7428 9.5161H89.7044L89.7428 10.8732V15.2614H88.8479Z"
        stroke="white"
        strokeWidth="0.22928"
        strokeMiterlimit="10"
      />
      <g filter="url(#filter0_ii)">
        <path
          d="M13.0476 8.84925C12.7089 9.21083 12.5088 9.77198 12.5088 10.4987V36.4619C12.5088 37.1897 12.7089 37.7497 13.0476 38.1113L13.1337 38.1958L27.5505 23.6517V23.4803V23.3089L13.1337 8.76355L13.0476 8.84925Z"
          fill="url(#paint0_linear)"
        />
        <path
          d="M32.3556 28.5013L27.5508 23.6517V23.4803V23.3089L32.3568 18.4604L32.465 18.5227L38.1589 21.7863C39.7845 22.7184 39.7845 24.2434 38.1589 25.1766L32.465 28.4402L32.3556 28.5013Z"
          fill="url(#paint1_linear)"
        />
        <g filter="url(#filter1_i)">
          <path
            d="M32.465 28.4391L27.5496 23.4803L13.0479 38.1114C13.5831 38.6842 14.4687 38.7547 15.466 38.1841L32.465 28.4391Z"
            fill="url(#paint2_linear)"
          />
        </g>
        <path
          d="M32.465 18.5215L15.466 8.77772C14.4687 8.206 13.5831 8.27761 13.0479 8.8505L27.5508 23.4815L32.465 18.5215Z"
          fill="url(#paint3_linear)"
        />
      </g>
      <defs>
        <filter
          id="filter0_ii"
          x="12.5088"
          y="8.38318"
          width="26.8693"
          height="30.195"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.17196" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.17196" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="effect1_innerShadow" result="effect2_innerShadow" />
        </filter>
        <filter
          id="filter1_i"
          x="13.0479"
          y="23.4803"
          width="19.4171"
          height="15.0979"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.17196" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
        </filter>
        <linearGradient
          id="paint0_linear"
          x1="26.2725"
          y1="10.224"
          x2="6.57199"
          y2="29.752"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.0066" stopColor="#00A1FF" />
          <stop offset="0.2601" stopColor="#00BEFF" />
          <stop offset="0.5122" stopColor="#00D2FF" />
          <stop offset="0.7604" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="40.275"
          y1="23.4803"
          x2="12.1188"
          y2="23.4803"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.4087" stopColor="#FFBD00" />
          <stop offset="0.7754" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="29.7956"
          y1="26.1733"
          x2="3.0792"
          y2="52.6558"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear"
          x1="9.39553"
          y1="0.207606"
          x2="21.3252"
          y2="12.0328"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.0685" stopColor="#2DA771" />
          <stop offset="0.4762" stopColor="#15CF74" />
          <stop offset="0.8009" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
      </defs>
    </svg>
  );
}
